module.exports = __webpack_public_path__ + "img/30_18.7dd0ef02.png";